if (!customElements.get('wonderly-quick-add')) {
  customElements.define(
    'wonderly-quick-add',
    class WonderlyQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onOutsidePointer = this.onOutsidePointer.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
      }

      connectedCallback() {
        this.submitButton = this.querySelector('.wonderly-pc__atc');
        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.form = this.closest('form');
        if (!this.submitButton || !this.quantityInput || !this.form) return;

        // Touch devices: CSS keeps the pill permanently open (no tap-to-expand
        // step), so the stepper is a plain always-visible control there.
        if (this.alwaysOpen) this.submitButton.setAttribute('aria-expanded', 'true');

        this.submitButton.addEventListener('click', this.onSubmitClick);
        this.form.addEventListener('submit', this.onFormSubmit);
      }

      get alwaysOpen() {
        return window.matchMedia('(hover: none)').matches;
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onOutsidePointer);
        document.removeEventListener('keyup', this.onKeyUp);
        clearTimeout(this.addedTimer);
      }

      onSubmitClick(event) {
        const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        // Fallback tap-to-expand only for devices that neither hover-expand
        // nor match the (hover: none) always-open CSS.
        if (!hoverCapable && !this.alwaysOpen && !this.classList.contains('is-open')) {
          event.preventDefault();
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        this.submitButton.setAttribute('aria-expanded', 'true');
        // Defer so the opening tap's pointerdown doesn't immediately close it.
        setTimeout(() => {
          document.addEventListener('pointerdown', this.onOutsidePointer);
          document.addEventListener('keyup', this.onKeyUp);
        });
      }

      close() {
        this.classList.remove('is-open');
        this.classList.remove('is-added');
        clearTimeout(this.addedTimer);
        this.submitButton.setAttribute('aria-expanded', 'false');
        document.removeEventListener('pointerdown', this.onOutsidePointer);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      onOutsidePointer(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyUp(event) {
        if (event.code === 'Escape') this.close();
      }

      onFormSubmit() {
        // product-form.js reads FormData synchronously during submit dispatch,
        // so a macrotask reset never races the cart request payload.
        setTimeout(() => {
          this.quantityInput.value = this.quantityInput.min || 1;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (this.alwaysOpen) {
            // Always-open pill: flash the ✓, then swap back to + — never collapse.
            this.classList.add('is-added');
            clearTimeout(this.addedTimer);
            this.addedTimer = setTimeout(() => this.classList.remove('is-added'), 1000);
          } else if (this.classList.contains('is-open')) {
            // Tap-to-expand flow: flash the ✓ briefly, then collapse.
            this.classList.add('is-added');
            clearTimeout(this.addedTimer);
            this.addedTimer = setTimeout(() => this.close(), 1000);
          } else {
            this.close();
          }
        });
      }
    }
  );
}
